(function () {
  function initProductMediaDots(container) {
    var productImages = container.closest('product-images');
    if (!productImages) return;

    var mediaList = productImages.querySelector('[data-product-media-list]');
    if (!mediaList) return;

    var dots = Array.prototype.slice.call(container.querySelectorAll('[data-media-id]'));
    if (!dots.length) return;

    var slides = Array.prototype.slice.call(mediaList.children).filter(function (el) {
      return el.hasAttribute('data-media-id');
    });

    function setActiveIndex(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var target = slides[index];
        if (!target) return;
        mediaList.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = slides.indexOf(entry.target);
          if (index > -1) setActiveIndex(index);
        });
      },
      { root: mediaList, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  }

  document.querySelectorAll('[data-product-slide-dots]').forEach(initProductMediaDots);
})();
